import H5JsApi from './core/h5-jsapi';
export { SDKFunction, type SdkResult, SdkError, SdkType } from './interface';
export type { ShareLinkOptions, ShareLinkResult } from './interface';
export { SdkResponseCode } from './constant';

export default H5JsApi;

export type {
    HeaderPosition,
    HeaderAction,
    SetHeaderActionsParams,
    ClearHeaderActionsParams,
    HeaderActionClickEvent,
    AddToDesktopParams,
    AddToDesktopResult
} from './interface/app';
